var cov_2qyix1rca9 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/filter.tsx",
      hash = "e6bf9ee3fbe6a7796886a80d0cfa6f400bcded09",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 21
        },
        end: {
          line: 12,
          column: 1
        }
      },
      "1": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "2": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 18
        }
      },
      "3": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "4": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 54
        }
      },
      "5": {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 64
        }
      },
      "6": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 38,
          column: 34
        }
      },
      "7": {
        start: {
          line: 42,
          column: 50
        },
        end: {
          line: 42,
          column: 60
        }
      },
      "8": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 40
        }
      },
      "9": {
        start: {
          line: 44,
          column: 17
        },
        end: {
          line: 44,
          column: 103
        }
      },
      "10": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 48,
          column: 7
        }
      },
      "11": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 59
        }
      },
      "12": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 110
        }
      },
      "13": {
        start: {
          line: 47,
          column: 61
        },
        end: {
          line: 47,
          column: 89
        }
      },
      "14": {
        start: {
          line: 49,
          column: 41
        },
        end: {
          line: 49,
          column: 43
        }
      },
      "15": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 59,
          column: 8
        }
      },
      "16": {
        start: {
          line: 51,
          column: 55
        },
        end: {
          line: 51,
          column: 100
        }
      },
      "17": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 55,
          column: 9
        }
      },
      "18": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 36
        }
      },
      "19": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 84
        }
      },
      "20": {
        start: {
          line: 54,
          column: 56
        },
        end: {
          line: 54,
          column: 84
        }
      },
      "21": {
        start: {
          line: 56,
          column: 8
        },
        end: {
          line: 58,
          column: 9
        }
      },
      "22": {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 57,
          column: 26
        }
      },
      "23": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "24": {
        start: {
          line: 64,
          column: 40
        },
        end: {
          line: 64,
          column: 50
        }
      },
      "25": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 72,
          column: 7
        }
      },
      "26": {
        start: {
          line: 68,
          column: 8
        },
        end: {
          line: 68,
          column: 87
        }
      },
      "27": {
        start: {
          line: 69,
          column: 8
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "28": {
        start: {
          line: 69,
          column: 24
        },
        end: {
          line: 69,
          column: 48
        }
      },
      "29": {
        start: {
          line: 70,
          column: 8
        },
        end: {
          line: 70,
          column: 42
        }
      },
      "30": {
        start: {
          line: 70,
          column: 22
        },
        end: {
          line: 70,
          column: 42
        }
      },
      "31": {
        start: {
          line: 71,
          column: 8
        },
        end: {
          line: 71,
          column: 14
        }
      },
      "32": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 74,
          column: 27
        }
      },
      "33": {
        start: {
          line: 74,
          column: 21
        },
        end: {
          line: 74,
          column: 27
        }
      },
      "34": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 41
        }
      },
      "35": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "36": {
        start: {
          line: 78,
          column: 22
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "37": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 84,
          column: 21
        }
      },
      "38": {
        start: {
          line: 80,
          column: 19
        },
        end: {
          line: 80,
          column: 39
        }
      },
      "39": {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      "40": {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 44
        }
      },
      "41": {
        start: {
          line: 94,
          column: 10
        },
        end: {
          line: 94,
          column: 20
        }
      },
      "42": {
        start: {
          line: 95,
          column: 42
        },
        end: {
          line: 95,
          column: 52
        }
      },
      "43": {
        start: {
          line: 96,
          column: 23
        },
        end: {
          line: 96,
          column: 63
        }
      },
      "44": {
        start: {
          line: 97,
          column: 20
        },
        end: {
          line: 97,
          column: 24
        }
      },
      "45": {
        start: {
          line: 98,
          column: 24
        },
        end: {
          line: 98,
          column: 32
        }
      },
      "46": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "47": {
        start: {
          line: 100,
          column: 45
        },
        end: {
          line: 100,
          column: 47
        }
      },
      "48": {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 110,
          column: 19
        }
      },
      "49": {
        start: {
          line: 105,
          column: 26
        },
        end: {
          line: 105,
          column: 55
        }
      },
      "50": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 40
        }
      },
      "51": {
        start: {
          line: 113,
          column: 6
        },
        end: {
          line: 123,
          column: 7
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 20,
            column: 16
          },
          end: {
            line: 20,
            column: 17
          }
        },
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 63
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 28
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 41,
            column: 24
          },
          end: {
            line: 61,
            column: 5
          }
        },
        line: 41
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 47,
            column: 56
          },
          end: {
            line: 47,
            column: 57
          }
        },
        loc: {
          start: {
            line: 47,
            column: 61
          },
          end: {
            line: 47,
            column: 89
          }
        },
        line: 47
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 20
          },
          end: {
            line: 50,
            column: 21
          }
        },
        loc: {
          start: {
            line: 50,
            column: 25
          },
          end: {
            line: 59,
            column: 7
          }
        },
        line: 50
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        loc: {
          start: {
            line: 63,
            column: 62
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 63
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 79,
            column: 30
          },
          end: {
            line: 79,
            column: 31
          }
        },
        loc: {
          start: {
            line: 79,
            column: 36
          },
          end: {
            line: 84,
            column: 7
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        loc: {
          start: {
            line: 87,
            column: 13
          },
          end: {
            line: 124,
            column: 5
          }
        },
        line: 87
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 105,
            column: 11
          }
        },
        loc: {
          start: {
            line: 105,
            column: 26
          },
          end: {
            line: 105,
            column: 55
          }
        },
        line: 105
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 18
          },
          end: {
            line: 43,
            column: 34
          }
        }, {
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 43,
            column: 40
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 44,
            column: 18
          },
          end: {
            line: 44,
            column: 83
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 44,
            column: 46
          },
          end: {
            line: 44,
            column: 62
          }
        }, {
          start: {
            line: 44,
            column: 65
          },
          end: {
            line: 44,
            column: 83
          }
        }],
        line: 44
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }, {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 48,
            column: 7
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 47,
            column: 61
          },
          end: {
            line: 47,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 61
          },
          end: {
            line: 47,
            column: 62
          }
        }, {
          start: {
            line: 47,
            column: 66
          },
          end: {
            line: 47,
            column: 89
          }
        }],
        line: 47
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 55
          },
          end: {
            line: 51,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 51,
            column: 65
          },
          end: {
            line: 51,
            column: 74
          }
        }, {
          start: {
            line: 51,
            column: 77
          },
          end: {
            line: 51,
            column: 100
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 55,
            column: 9
          }
        }],
        line: 52
      },
      "6": {
        loc: {
          start: {
            line: 54,
            column: 10
          },
          end: {
            line: 54,
            column: 84
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 10
          },
          end: {
            line: 54,
            column: 84
          }
        }, {
          start: {
            line: 54,
            column: 10
          },
          end: {
            line: 54,
            column: 84
          }
        }],
        line: 54
      },
      "7": {
        loc: {
          start: {
            line: 54,
            column: 14
          },
          end: {
            line: 54,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 14
          },
          end: {
            line: 54,
            column: 17
          }
        }, {
          start: {
            line: 54,
            column: 21
          },
          end: {
            line: 54,
            column: 29
          }
        }, {
          start: {
            line: 54,
            column: 33
          },
          end: {
            line: 54,
            column: 54
          }
        }],
        line: 54
      },
      "8": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }, {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 58,
            column: 9
          }
        }],
        line: 56
      },
      "9": {
        loc: {
          start: {
            line: 63,
            column: 31
          },
          end: {
            line: 63,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 63,
            column: 60
          }
        }],
        line: 63
      },
      "10": {
        loc: {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }, {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 72,
            column: 7
          }
        }],
        line: 67
      },
      "11": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 48
          }
        }, {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 48
          }
        }],
        line: 69
      },
      "12": {
        loc: {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 42
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 42
          }
        }],
        line: 70
      },
      "13": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 27
          }
        }, {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 74,
            column: 27
          }
        }],
        line: 74
      },
      "14": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 78,
            column: 46
          }
        }],
        line: 78
      },
      "15": {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }],
        line: 81
      },
      "16": {
        loc: {
          start: {
            line: 89,
            column: 8
          },
          end: {
            line: 89,
            column: 32
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 89,
            column: 15
          },
          end: {
            line: 89,
            column: 32
          }
        }],
        line: 89
      },
      "17": {
        loc: {
          start: {
            line: 92,
            column: 8
          },
          end: {
            line: 92,
            column: 60
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 92,
            column: 29
          },
          end: {
            line: 92,
            column: 60
          }
        }],
        line: 92
      },
      "18": {
        loc: {
          start: {
            line: 96,
            column: 23
          },
          end: {
            line: 96,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 96,
            column: 34
          },
          end: {
            line: 96,
            column: 51
          }
        }, {
          start: {
            line: 96,
            column: 54
          },
          end: {
            line: 96,
            column: 63
          }
        }],
        line: 96
      },
      "19": {
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }],
        line: 99
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/TreeSelect/filter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import { getFilterTree } from '../utils/tree';
import { isArray } from '../utils/is';
var DefaultValue = (cov_2qyix1rca9.s[0]++, {
  data: [],
  filterDelay: 300,
  showHitDescendants: false
});
export default (function (Origin) {
  var _class, _temp;

  cov_2qyix1rca9.f[0]++;
  cov_2qyix1rca9.s[1]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Filter, _Component);

    var _super = _createSuper2(Filter);

    function Filter(props) {
      var _this;

      _classCallCheck(this, Filter);

      cov_2qyix1rca9.f[1]++;
      cov_2qyix1rca9.s[2]++;
      _this = _super.call(this, props);
      _this.resultCache = void 0;
      _this.timer = void 0;
      cov_2qyix1rca9.s[3]++;
      _this.state = {
        innerFilter: undefined,
        innerData: undefined,
        filterText: ''
      };
      cov_2qyix1rca9.s[4]++;
      _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
      cov_2qyix1rca9.s[5]++;
      _this.getResultByValues = _this.getResultByValues.bind(_assertThisInitialized(_this));
      cov_2qyix1rca9.s[6]++;
      _this.resultCache = new Map();
      return _this;
    }

    _createClass(Filter, [{
      key: "getResultByValues",
      value: function getResultByValues() {
        var _this2 = this;

        cov_2qyix1rca9.f[2]++;

        var _ref = (cov_2qyix1rca9.s[7]++, this.props),
            datum = _ref.datum,
            noCache = _ref.noCache,
            renderUnmatched = _ref.renderUnmatched;

        var value = (cov_2qyix1rca9.s[8]++, (cov_2qyix1rca9.b[0][0]++, datum.getValue()) || (cov_2qyix1rca9.b[0][1]++, []));
        var vr = (cov_2qyix1rca9.s[9]++, isArray(this.props.value) ? (cov_2qyix1rca9.b[1][0]++, this.props.value) : (cov_2qyix1rca9.b[1][1]++, [this.props.value]));
        cov_2qyix1rca9.s[10]++;

        if (renderUnmatched) {
          cov_2qyix1rca9.b[2][0]++;
          var emptyArr = (cov_2qyix1rca9.s[11]++, []);
          cov_2qyix1rca9.s[12]++;
          value = value.concat(emptyArr.concat(vr).filter(function (v) {
            cov_2qyix1rca9.f[3]++;
            cov_2qyix1rca9.s[13]++;
            return (cov_2qyix1rca9.b[3][0]++, v) && (cov_2qyix1rca9.b[3][1]++, value.indexOf(v) === -1);
          }));
        } else {
          cov_2qyix1rca9.b[2][1]++;
        }

        var result = (cov_2qyix1rca9.s[14]++, []);
        cov_2qyix1rca9.s[15]++;
        value.forEach(function (v) {
          cov_2qyix1rca9.f[4]++;
          var res = (cov_2qyix1rca9.s[16]++, noCache ? (cov_2qyix1rca9.b[4][0]++, undefined) : (cov_2qyix1rca9.b[4][1]++, _this2.resultCache.get(v)));
          cov_2qyix1rca9.s[17]++;

          if (!res) {
            cov_2qyix1rca9.b[5][0]++;
            cov_2qyix1rca9.s[18]++;
            res = datum.getDataById(v);
            cov_2qyix1rca9.s[19]++;

            if ((cov_2qyix1rca9.b[7][0]++, res) && (cov_2qyix1rca9.b[7][1]++, !noCache) && (cov_2qyix1rca9.b[7][2]++, !datum.isUnMatch(res))) {
              cov_2qyix1rca9.b[6][0]++;
              cov_2qyix1rca9.s[20]++;

              _this2.resultCache.set(v, res);
            } else {
              cov_2qyix1rca9.b[6][1]++;
            }
          } else {
            cov_2qyix1rca9.b[5][1]++;
          }

          cov_2qyix1rca9.s[21]++;

          if (res) {
            cov_2qyix1rca9.b[8][0]++;
            cov_2qyix1rca9.s[22]++;
            result.push(res);
          } else {
            cov_2qyix1rca9.b[8][1]++;
          }
        });
        cov_2qyix1rca9.s[23]++;
        return result;
      }
    }, {
      key: "handleFilter",
      value: function handleFilter(text) {
        var _this3 = this;

        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2qyix1rca9.b[9][0]++, 'edit');
        cov_2qyix1rca9.f[5]++;

        var _ref2 = (cov_2qyix1rca9.s[24]++, this.props),
            filterDelay = _ref2.filterDelay,
            onFilter = _ref2.onFilter; // not filter


        cov_2qyix1rca9.s[25]++;

        if (!text) {
          cov_2qyix1rca9.b[10][0]++;
          cov_2qyix1rca9.s[26]++;
          this.setState({
            filterText: '',
            innerFilter: undefined,
            innerData: undefined
          });
          cov_2qyix1rca9.s[27]++;

          if (this.timer) {
            cov_2qyix1rca9.b[11][0]++;
            cov_2qyix1rca9.s[28]++;
            clearTimeout(this.timer);
          } else {
            cov_2qyix1rca9.b[11][1]++;
          }

          cov_2qyix1rca9.s[29]++;

          if (onFilter) {
            cov_2qyix1rca9.b[12][0]++;
            cov_2qyix1rca9.s[30]++;
            onFilter(text, from);
          } else {
            cov_2qyix1rca9.b[12][1]++;
          }

          cov_2qyix1rca9.s[31]++;
          return;
        } else {
          cov_2qyix1rca9.b[10][1]++;
        }

        cov_2qyix1rca9.s[32]++;

        if (!onFilter) {
          cov_2qyix1rca9.b[13][0]++;
          cov_2qyix1rca9.s[33]++;
          return;
        } else {
          cov_2qyix1rca9.b[13][1]++;
        }

        cov_2qyix1rca9.s[34]++;
        this.setState({
          filterText: text
        });
        cov_2qyix1rca9.s[35]++;

        if (this.timer) {
          cov_2qyix1rca9.b[14][0]++;
          cov_2qyix1rca9.s[36]++;
          clearTimeout(this.timer);
        } else {
          cov_2qyix1rca9.b[14][1]++;
        }

        cov_2qyix1rca9.s[37]++;
        this.timer = setTimeout(function () {
          cov_2qyix1rca9.f[6]++;
          var fn = (cov_2qyix1rca9.s[38]++, onFilter(text, from));
          cov_2qyix1rca9.s[39]++;

          if (typeof fn === 'function') {
            cov_2qyix1rca9.b[15][0]++;
            cov_2qyix1rca9.s[40]++;

            _this3.setState({
              innerFilter: fn
            });
          } else {
            cov_2qyix1rca9.b[15][1]++;
          }
        }, filterDelay);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        cov_2qyix1rca9.f[7]++;

        var _ref3 = (cov_2qyix1rca9.s[41]++, this.props),
            _ref3$data = _ref3.data,
            data = _ref3$data === void 0 ? (cov_2qyix1rca9.b[16][0]++, DefaultValue.data) : _ref3$data,
            onFilter = _ref3.onFilter,
            expanded = _ref3.expanded,
            _ref3$showHitDescenda = _ref3.showHitDescendants,
            showHitDescendants = _ref3$showHitDescenda === void 0 ? (cov_2qyix1rca9.b[17][0]++, DefaultValue.showHitDescendants) : _ref3$showHitDescenda,
            other = _objectWithoutProperties(_ref3, ["data", "onFilter", "expanded", "showHitDescendants"]);

        var _ref4 = (cov_2qyix1rca9.s[42]++, this.state),
            innerFilter = _ref4.innerFilter,
            filterText = _ref4.filterText;

        var filterFn = (cov_2qyix1rca9.s[43]++, onFilter ? (cov_2qyix1rca9.b[18][0]++, this.handleFilter) : (cov_2qyix1rca9.b[18][1]++, undefined));
        var newData = (cov_2qyix1rca9.s[44]++, data);
        var newExpanded = (cov_2qyix1rca9.s[45]++, expanded);
        cov_2qyix1rca9.s[46]++;

        if (innerFilter) {
          cov_2qyix1rca9.b[19][0]++;
          var filterExpandedKeys = (cov_2qyix1rca9.s[47]++, []);
          cov_2qyix1rca9.s[48]++;
          newData = getFilterTree(data, innerFilter, filterExpandedKeys, function (node) {
            cov_2qyix1rca9.f[8]++;
            cov_2qyix1rca9.s[49]++;
            return _this4.props.datum.getKey(node);
          }, other.childrenKey, showHitDescendants, undefined, {
            advanced: other.onAdvancedFilter
          });
          cov_2qyix1rca9.s[50]++;
          newExpanded = filterExpandedKeys;
        } else {
          cov_2qyix1rca9.b[19][1]++;
        }

        cov_2qyix1rca9.s[51]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, other, {
            filterText: filterText,
            result: this.getResultByValues(),
            data: newData,
            rawData: data,
            onFilter: filterFn,
            expanded: newExpanded,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 114,
              columnNumber: 9
            }
          }))
        );
      }
    }]);

    return Filter;
  }(Component), _class.defaultProps = DefaultValue, _temp;
});